import React from 'react'

// project-imports
import SEO from '../../common/SEO';
import Layout from '../../common/Layout';
import StencilBox from '../../components/stencils/StencilBox';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';

const PrivacyPolicyStencil = () => {
    
    return (
        <>
            {/* <SEO title="Privacy Policy" /> Set SEO title */}
            <Layout searchDisable={true}>
                <BreadcrumbOne
                    title="Privacy Policy" // Breadcrumb title
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Privacy Policy"
                />
                <div className="edu-privacy-policy-area edu-privacy-policy edu-section-gap bg-stencil">
                    <div className="container">
                        <div className="row g-5">
                            <div className="content">
                                <div className="thumbnail mb--50">
                                    <StencilBox
                                        width="100%"
                                        height="483.08px"
                                        backgroundColor="#F5F5F5"
                                        border="none"
                                    />

                                </div>

                                <h4 className="title">
                                    <StencilBox
                                        width="100%"
                                        height="44.16px"
                                        backgroundColor="#F5F5F5"
                                        border="none"
                                    />
                                </h4>
                                <p>
                                    <StencilBox
                                        width="100%"
                                        height="52.13px"
                                        backgroundColor="#F5F5F5"
                                        border="none"
                                    />
                                </p>

                                <h4 className="title"><StencilBox
                                    width="100%"
                                    height="44.16px"
                                    backgroundColor="#F5F5F5"
                                    border="none"
                                /></h4>
                                <ul className="stencil">
                                    <li >
                                        <b></b><StencilBox
                                            width="100%"
                                            height="52.13px"
                                            backgroundColor="#F5F5F5"
                                            border="none"
                                        /></li>
                                    <li ><b></b><StencilBox
                                        width="100%"
                                        height="52.13px"
                                        backgroundColor="#F5F5F5"
                                        border="none"
                                    /></li>
                                    <li ><b></b> <StencilBox
                                        width="100%"
                                        height="52.13px"
                                        backgroundColor="#F5F5F5"
                                        border="none"
                                    /></li>
                                </ul>

                                <h4 className="title">
                                    <StencilBox
                                        width="100%"
                                        height="44.16px"
                                        backgroundColor="#F5F5F5"
                                        border="none"
                                    />
                                </h4>
                                <ul className="stencil">
                                    <li ><b></b><StencilBox
                                        width="100%"
                                        height="52.13px"
                                        backgroundColor="#F5F5F5"
                                        border="none"
                                    /></li>
                                    <li ><b></b><StencilBox
                                        width="100%"
                                        height="52.13px"
                                        backgroundColor="#F5F5F5"
                                        border="none"
                                    /></li>
                                    <li ><b></b><StencilBox
                                        width="100%"
                                        height="52.13px"
                                        backgroundColor="#F5F5F5"
                                        border="none"
                                    /></li>
                                </ul>

                                <h4 className="title"><StencilBox
                                    width="100%"
                                    height="44.16px"
                                    backgroundColor="#F5F5F5"
                                    border="none"
                                /></h4>
                                <ul className="stencil">
                                    <li ><b></b><StencilBox
                                        width="100%"
                                        height="52.13px"
                                        backgroundColor="#F5F5F5"
                                        border="none"
                                    /></li>
                                    <li ><b></b><StencilBox
                                        width="100%"
                                        height="52.13px"
                                        backgroundColor="#F5F5F5"
                                        border="none"
                                    /></li>
                                </ul>

                                <h4 className="title"><StencilBox
                                    width="100%"
                                    height="44.16px"
                                    backgroundColor="#F5F5F5"
                                    border="none"
                                /></h4>
                                <p><StencilBox
                                    width="100%"
                                    height="52.13px"
                                    backgroundColor="#F5F5F5"
                                    border="none"
                                /></p>

                                <h4 className="title"><StencilBox
                                    width="100%"
                                    height="44.16px"
                                    backgroundColor="#F5F5F5"
                                    border="none"
                                /></h4>
                                <p><StencilBox
                                    width="100%"
                                    height="52.13px"
                                    backgroundColor="#F5F5F5"
                                    border="none"
                                /></p>

                                <h4 className="title"><StencilBox
                                    width="100%"
                                    height="44.16px"
                                    backgroundColor="#F5F5F5"
                                    border="none"
                                /></h4>
                                <p><StencilBox
                                    width="100%"
                                    height="52.13px"
                                    backgroundColor="#F5F5F5"
                                    border="none"
                                /> </p>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}
export default PrivacyPolicyStencil;